import React, { FunctionComponent } from 'react';
import { useDonatePopup } from 'src/components/DonatePopup/DonatePopupContext';
import DonatePopupRefocusModal from 'src/components/DonatePopup/DonatePopupRefocusModal';
import DonatePopupBlockedModal from 'src/components/DonatePopup/DonatePopupBlockedModal';

const DonatePopup: FunctionComponent = () => {
  const { popupCheckoutMode } = useDonatePopup();

  if (popupCheckoutMode === 'open') {
    return <DonatePopupRefocusModal />;
  }
  if (popupCheckoutMode === 'blocked') {
    return <DonatePopupBlockedModal />;
  }
  return null;
};

export default DonatePopup;



// WEBPACK FOOTER //
// ./src/components/DonatePopup/DonatePopup.tsx